export class Service {
  id: number;
  label_pl: string;
  code: string;
  description: string;
  is_active: boolean;
  is_internal: boolean;
  need_extra_authorization: boolean;
  main_page: string;
  can_be_integrated: boolean;

  constructor() {
    this.is_active = false;
    this.is_internal = false;
    this.need_extra_authorization = false;
    this.can_be_integrated = false;
    this.main_page = 'https://legia.com';
  }
}
